<template>
    <transition  >
    <div class="container-fluid ">
        <div class="row">
                <div class="col-12">
                    <div class="page-title-box">
                        <div class="page-title-right float-left">
                            <ol class="breadcrumb m-0"> 
                                <li class="breadcrumb-item active">Diagnosis Billing </li>
                                <li class="breadcrumb-item"><a href="javascript: void(0);">Report Generate Process</a></li>
                                
                            </ol>
                        </div>
                    </div>
                </div>
            </div>  
            <div class="row">
                <div class="col-12">
                    <!-- Search and export area -->
                    <div class="card">
                        <div class="card-header">
                            <div class="row">      
                                <div class="col-md-4">
                                    <div class="row">
                                        <div class="col-md-6 mb-3">
                                            <div class="form-check">
                                                <input type="radio" id="report_generate" name="form_type" class="form-check-input" value="generate" checked @change="onChangeReportForm($event)">
                                                <label class="form-check-label" for="report_generate" style="font-size: 18px; font-weight: bold;">Generate</label>
                                            </div>
                                        </div>

                                        <div class="col-md-6 mb-3">
                                            <div class="form-check">
                                                <input type="radio" id="report_receive_print" name="form_type" class="form-check-input" value="receive_print" @change="onChangeReportForm($event)"> 
                                                <label class="form-check-label" for="report_receive_print" style="font-size: 18px; font-weight: bold;">Print</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>                  
                                <div class="col-md-5">
                                    <div class="mb-1">
                                        <div class="form-group autocomplete">
                                            <input
                                                type="text"
                                                v-model="searchTerm"
                                                class="form-control"
                                                placeholder="Scan/Search Test Invoice"
                                                @keyup.enter="fetchDiagnosisBillingInvoice()" 
                                                
                                            />
                                            <div class="invalid-feedback" v-if="errors.searchTerm">
                                                {{errors.searchTerm[0]}}
                                            </div>
                                            <ul
                                                v-if="searchTests.length"
                                                class="w-full rounded bg-white border border-gray-300 px-4 py-2 space-y-1 absolute z-10 autocomplete-results"
                                            >
                                                <li>
                                                    Showing {{ searchTests.length }} of {{ test_items.length }} results
                                                </li>
                                                <li
                                                v-for="(item, i) in searchTests.slice(0, 15)"
                                                :key="item.name"
                                                @change="selectTests(item)"
                                                @click="setResult(item)"
                                                class="cursor-pointer hover:bg-gray-100 p-1"
                                                :class="{ 'is-active': i === arrowCounter }"
                                                >
                                                {{ item.name }}
                                                </li>
                                            </ul>
                                        </div>
                                    </div>    
                                </div>
                                <div class="col-md-3"></div>
                            </div>
                        </div>

                        <div class="card-body">   
                            <form v-if="!loading">
                                <!-- Bill Information -->
                                <div class="row mb-3">
                                    <div class="col-md-12">
                                        <h4 class="wpr_general_sign_title">Invoice, Patient information and Other's </h4>
                                    </div>

                                    <div class="col-md-12">
                                        <div class="row">
                                            <div class="col-md-6 mb-1">
                                                <div class="row">
                                                    <div class="col-md-4">
                                                        <label for="bill_no" style="width: 100%; height: 34px; padding: 10px;">Invoice No <span style="color: red">*</span></label>
                                                    </div>
                                                    <div class="col-md-8">
                                                        <input type="text" class="form-control border" v-model="form.bill_no" placeholder="Enter Bill No" readonly  @keypress="onkeyPress('bill_no')">
                                                        <div class="invalid-feedback" v-if="errors.bill_no">
                                                            {{errors.bill_no[0]}}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            
                                            <div class="col-md-6 mb-1">
                                                <div class="row">
                                                    <div class="col-md-4">
                                                        <label for="bill_date" style="width: 100%; height: 34px; padding: 10px;">Invoice Date  <span style="color: red">*</span></label>
                                                    </div>
                                                    <div class="col-md-8">
                                                        <input type="date" class="form-control border" v-model="form.bill_date" placeholder="Enter Date" readonly @keypress="onkeyPress('bill_date')">
                                                        <div class="invalid-feedback" v-if="errors.bill_date">
                                                            {{errors.bill_date[0]}}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            
                                            <div class="col-md-6 mb-1">
                                                <div class="row">
                                                    <div class="col-md-4">
                                                        <label for="patient_name" style="width: 100%; height: 34px; padding: 10px;">Patient Name  <span style="color: red">*</span></label>
                                                    </div>
                                                    <div class="col-md-8">
                                                        <input type="text" class="form-control border" v-model="form.patient_name" placeholder="Enter Patient Name" readonly @keypress="onkeyPress('patient_name')">
                                                        <div class="invalid-feedback" v-if="errors.patient_name">
                                                            {{errors.patient_name[0]}}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            
                                            <div class="col-md-6 mb-1">
                                                <div class="row">
                                                    <div class="col-md-4">
                                                        <label for="patient_phone" style="width: 100%; height: 34px; padding: 10px;">Patient Phone <span style="color: red">*</span></label>
                                                    </div>
                                                    <div class="col-md-8">
                                                        <input type="text" class="form-control border" v-model="form.patient_phone" placeholder="Enter Patient Phone" readonly @keypress="onkeyPress('patient_phone')">
                                                        <div class="invalid-feedback" v-if="errors.patient_phone">
                                                            {{errors.patient_phone[0]}}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            
                                            <div class="col-md-6 mb-1">
                                                <div class="row">
                                                    <div class="col-md-4">
                                                        <label for="patient_age" style="width: 100%; height: 34px; padding: 10px;">Patient Age <span style="color: red"></span></label>
                                                    </div>
                                                    <div class="col-md-8">
                                                        <input type="text" class="form-control border" v-model="form.patient_age" placeholder="Enter Patient Age" readonly @keypress="onkeyPress('patient_age')">
                                                        <div class="invalid-feedback" v-if="errors.patient_age">
                                                            {{errors.patient_age[0]}}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            
                                            <div class="col-md-6 mb-1">
                                                <div class="row">
                                                    <div class="col-md-4">
                                                        <label for="patient_gender" style="width: 100%; height: 34px; padding: 10px;">Gender <span style="color: red"></span></label>
                                                    </div>
                                                    <div class="col-md-8" style="pointer-events: none;">
                                                        <Multiselect 
                                                            class="form-control border" 
                                                            mode="single"
                                                            v-model="form.patient_gender"
                                                            placeholder="Gender"  
                                                            :searchable="true" 
                                                            :filter-results="true"
                                                            :options="gender_options"
                                                            :classes="multiclasses"
                                                            :close-on-select="true" 
                                                            :min-chars="1"
                                                            :resolve-on-load="false" 
                                                            :create-option="false" 
                                                            @change="onkeyPress('patient_gender')"
                                                            v-if="renderOptionComponent"
                                                        />  
                                                        <div class="invalid-feedback" v-if="errors.patient_gender">
                                                            {{errors.patient_gender[0]}}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            
                                            <div class="col-md-6 mb-1">
                                                <div class="row">
                                                    <div class="col-md-4">
                                                        <label for="reference_type" style="width: 100%; height: 34px; padding: 10px;">Reference Type <span style="color: red">*</span></label>
                                                    </div>
                                                    <div class="col-md-8" style="pointer-events: none;">
                                                        <Multiselect 
                                                            class="form-control border" 
                                                            mode="single"
                                                            v-model="form.reference_type"
                                                            placeholder="Select Reference Type"  
                                                            :searchable="true" 
                                                            :filter-results="true"
                                                            :options="[{label:'Doctor', value:'doctor'}, {label:'Self', value:'self'}, {label:'Others', value:'others'}]"
                                                            :classes="multiclasses"
                                                            :close-on-select="true" 
                                                            :min-chars="1"
                                                            :resolve-on-load="false" 
                                                            :create-option="false" 
                                                            v-if="renderOptionComponent"
                                                        />                                                   
                                                        <div class="invalid-feedback" v-if="errors.reference_type">
                                                            {{errors.reference_type[0]}}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            
                                            <div class="col-md-6 mb-1">
                                                <div class="row">
                                                    <div class="col-md-4">
                                                        <label for="reference_person_id" style="width: 100%; height: 34px; padding: 10px;">Reference Person <span style="color: red">*</span></label>
                                                    </div>
                                                    <div class="col-md-8" style="pointer-events: none;">
                                                        <input type="hidden" class="form-control border" v-model="form.reference_person_name">
                                                        <Multiselect 
                                                            class="form-control border" 
                                                            mode="single"
                                                            v-model="form.reference_person_id"
                                                            placeholder="Select Reference"  
                                                            :searchable="true" 
                                                            :filter-results="true"
                                                            :options="doctor_options"
                                                            :classes="multiclasses"
                                                            :close-on-select="true" 
                                                            :min-chars="1"
                                                            :resolve-on-load="false"
                                                            :create-option="true" 
                                                            @change="changeReferencePerson"
                                                            v-if="renderOptionComponent"
                                                        />                                                   
                                                        <div class="invalid-feedback" v-if="errors.reference_person_id">
                                                            {{errors.reference_person_id[0]}}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            
                                            <div class="col-md-6 mb-1">
                                                <div class="row">
                                                    <div class="col-md-4">
                                                        <label for="delivery_date" style="width: 100%; height: 34px; padding: 10px;">Date of Delivery  <span style="color: red">*</span></label>
                                                    </div>
                                                    <div class="col-md-8">
                                                        <input type="date" class="form-control border" v-model="form.delivery_date" readonly @change="changeDeliveryDateTime(), onkeyPress('delivery_date')" placeholder="Enter Date">
                                                        <div class="invalid-feedback" v-if="errors.delivery_date">
                                                            {{errors.delivery_date[0]}}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <!-- <div class="row" v-if="form.bill_no != ''">
                                            <div class="col-md-12 mb-1" style="text-align: right;">
                                                <button type="button" class="btn btn-primary btn-sm" title="Label Print" style="margin-right: 5px;" @click="singleBarcode(form)">
                                                    <i class="fas fa-print"></i> Label Print
                                                </button>
                                            </div>
                                        </div> -->

                                        <hr>

                                        <!-- Diagnosis Test Information -->
                                        <div class="item_area" v-if="form_type == 'generate'">
                                            
                                            <div class="row">      
                                                <div class="col-md-6">
                                                    <div class="row">
                                                        <div class="col-md-6">
                                                            <div class="mb-1">
                                                                <div class="form-group">
                                                                    <Multiselect 
                                                                        class="form-control border" 
                                                                        mode="single"
                                                                        v-model="form.test_id"
                                                                        placeholder="Select Test"  
                                                                        :searchable="true" 
                                                                        :filter-results="true"
                                                                        :options="test_options"
                                                                        :classes="multiclasses"
                                                                        :close-on-select="true" 
                                                                        :min-chars="1"
                                                                        :resolve-on-load="false"
                                                                        :create-option="false" 
                                                                        @change="changeTestItem($event)"
                                                                        v-if="renderOptionComponent"
                                                                    />                                               
                                                                    <div class="invalid-feedback" v-if="errors.test_id">
                                                                        {{errors.test_id[0]}}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>                  
                                                        <div class="col-md-6">
                                                            <div class="mb-1">
                                                                <div class="form-group">
                                                                    <Multiselect 
                                                                        class="form-control border" 
                                                                        mode="single"
                                                                        v-model="form.report_type"
                                                                        placeholder="Select Report Type"  
                                                                        :searchable="true" 
                                                                        :filter-results="true"
                                                                        :options="report_type_options"
                                                                        :classes="multiclasses"
                                                                        :close-on-select="true" 
                                                                        :min-chars="1"
                                                                        :resolve-on-load="false"
                                                                        :create-option="false" 
                                                                        @change="changeReportType($event)"
                                                                        v-if="renderOptionComponent"
                                                                    />                                               
                                                                    <div class="invalid-feedback" v-if="errors.report_type">
                                                                        {{errors.report_type[0]}}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div class="col-md-6">
                                                            <div class="mb-1">
                                                                <div class="form-group">
                                                                    <input type="text" class="form-control border" v-model="form.specimen" placeholder="Enter Specimen" @keypress="onkeyPress('specimen')">                                              
                                                                    <div class="invalid-feedback" v-if="errors.specimen">
                                                                        {{errors.specimen[0]}}
                                                                    </div>
                                                                </div>  
                                                            </div>
                                                        </div>

                                                        <div class="col-md-12">
                                                            <div class="mb-1">
                                                                <div class="form-group">
                                                                    <textarea class="form-control border" v-model="form.exm_machine_info" placeholder="Enter Machine Info" @keypress="onkeyPress('exm_machine_info')"> </textarea>                                             
                                                                    <div class="invalid-feedback" v-if="errors.exm_machine_info">
                                                                        {{errors.exm_machine_info[0]}}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <!-- <div class="col-md-3">
                                                    <div class="mb-1">
                                                        <div class="form-group">
                                                            <Multiselect 
                                                                class="form-control border" 
                                                                mode="single"
                                                                v-model="form.tester_by"
                                                                placeholder="Select Pathologist/Radiologist"  
                                                                :searchable="true" 
                                                                :filter-results="true"
                                                                :options="doctor_options"
                                                                :classes="multiclasses"
                                                                :close-on-select="true" 
                                                                :min-chars="1"
                                                                :resolve-on-load="false"
                                                                :create-option="true" 
                                                                @change="changeDiagnosisTester($event)"
                                                                v-if="renderOptionComponent"
                                                            />                                               
                                                            <div class="invalid-feedback" v-if="errors.tester_by">
                                                                {{errors.tester_by[0]}}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div> -->
                                            
                                                <div class="col-md-3">
                                                    <div class="row">
                                                        <div class="col-md-12">
                                                            <div class="mb-1">
                                                                <div class="form-group">
                                                                    <div class="form-check">
                                                                        <input
                                                                            class="form-check-input"
                                                                            type="checkbox"
                                                                            id="mannual_pathologist"
                                                                            v-model="mannual_pathologist"
                                                                            @input="changeMannualTester"
                                                                        />
                                                                        <label class="form-check-label" for="mannual_pathologist" style="font-weight: 600;">
                                                                            Add Mannual Pathologist/Radiologist
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="row">
                                                        <div class="col-md-12">
                                                            <div class="mb-1">
                                                                <div class="form-group" v-if="mannual_pathologist">
                                                                    <input type="hidden" class="form-control border" v-model="form.tester_by">
                                                                    <input type="text" class="form-control border" v-model="form.tester_by_name" placeholder="Enter Pathologist/Radiologist Name" @keypress="onkeyPress('tester_by_name')">                                        
                                                                    <div class="invalid-feedback" v-if="errors.tester_by_name">
                                                                        {{errors.tester_by_name[0]}}
                                                                    </div>
                                                                </div>
                                                                <div class="form-group" v-else>
                                                                    <Multiselect 
                                                                        class="form-control border" 
                                                                        mode="single"
                                                                        v-model="form.tester_by"
                                                                        placeholder="Select Pathologist/Radiologist"  
                                                                        :searchable="true" 
                                                                        :filter-results="true"
                                                                        :options="doctor_options"
                                                                        :classes="multiclasses"
                                                                        :close-on-select="true" 
                                                                        :min-chars="1"
                                                                        :resolve-on-load="false"
                                                                        :create-option="true" 
                                                                        @change="changeDiagnosisTester($event)"
                                                                        v-if="renderOptionComponent"
                                                                    />                                               
                                                                    <div class="invalid-feedback" v-if="errors.tester_by">
                                                                        {{errors.tester_by[0]}}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-12" v-if="mannual_pathologist">
                                                            <div class="mb-1">
                                                                <div class="form-group">
                                                                    <input type="text" class="form-control border" v-model="form.tester_specialist" placeholder="Enter Pathologist/Radiologist Speciality" @keypress="onkeyPress('tester_specialist')">
                                                                    <div class="invalid-feedback" v-if="errors.tester_specialist">
                                                                        {{errors.tester_specialist[0]}} 
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-12" v-if="mannual_pathologist">
                                                            <div class="mb-1">
                                                                <div class="form-group">
                                                                    <input type="text" class="form-control border" v-model="form.tester_qualification" placeholder="Enter Pathologist/Radiologist Qualification" @keypress="onkeyPress('tester_qualification')">
                                                                    <div class="invalid-feedback" v-if="errors.tester_qualification">
                                                                        {{errors.tester_qualification[0]}} 
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="col-md-3">
                                                    <div class="row">
                                                        <div class="col-md-12">
                                                            <div class="mb-1">
                                                                <div class="form-group">
                                                                    <div class="form-check">
                                                                        <input
                                                                            class="form-check-input"
                                                                            type="checkbox"
                                                                            id="mannual_medical_officer"
                                                                            v-model="mannual_medical_officer"
                                                                            @input="changeMannualMedicalOfficer"
                                                                        />
                                                                        <label class="form-check-label" for="mannual_medical_officer" style="font-weight: 600;">
                                                                            Add Mannual Medical Officer
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="row">
                                                        <div class="col-md-12">
                                                            <div class="mb-1">
                                                                <div class="form-group">
                                                                    <input type="text" class="form-control border" v-model="form.medical_officer_by_name" :readonly="!mannual_medical_officer" placeholder="Enter Name" @keypress="onkeyPress('medical_officer_by_name')">                                        
                                                                    <div class="invalid-feedback" v-if="errors.medical_officer_by_name">
                                                                        {{errors.medical_officer_by_name[0]}}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-12">
                                                            <div class="mb-1">
                                                                <div class="form-group">
                                                                    <input type="text" class="form-control border" v-model="form.medical_officer_qualification" :readonly="!mannual_medical_officer" placeholder="Enter Qualicafication" @keypress="onkeyPress('medical_officer_qualification')">
                                                                    <div class="invalid-feedback" v-if="errors.medical_officer_qualification">
                                                                        {{errors.medical_officer_qualification[0]}} 
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-12">
                                                            <div class="mb-1">
                                                                <div class="form-group">
                                                                    <input type="text" class="form-control border" v-model="form.medical_officer_designation" :readonly="!mannual_medical_officer" placeholder="Enter Designation with Department" @keypress="onkeyPress('medical_officer_designation')">
                                                                    <div class="invalid-feedback" v-if="errors.medical_officer_designation">
                                                                        {{errors.medical_officer_designation[0]}} 
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <hr>

                                            <div class="row">
                                                <div class="col-md-12">
                                                    <div class="table-responsive" style="padding: 0;" v-if="this.form && Array.isArray(this.form.report_items) && this.form.report_items.length > 0 && form.report_type == 'parameter'" >
                                                        <table class="table table-border table-sm table-nowrap mb-0">
                                                            <thead class="thead-light">
                                                                <tr>
                                                                    <th style="width: 5%;">#</th>
                                                                    <th style="width: 20%;">Parameter</th>
                                                                    <th style="width: 10%;">Result</th>
                                                                    <th style="width: 10%; text-align: center;">M Unit</th>
                                                                    <th style="width: 10%;">Reference Value</th>
                                                                    <th style="width: 10%;">Method</th>
                                                                </tr>
                                                            </thead>

                                                            <tbody> 
                                                                <tr v-for="(item, index) in form.report_items" :key="index">
                                                                    <td>{{ index + 1 }}</td> 
                                                                    <td>{{ item.parameter_name }}</td>
                                                                    <td><input type="text" class="form-control border" v-model="item.result" placeholder="Enter Result" @keypress="onkeyPress('result')"></td> 
                                                                    <td style="text-align: center;">{{ item.unit_name }}</td> 
                                                                    <td>{{ item.reference_value }}</td> 
                                                                    <td><input type="text" class="form-control border" v-model="item.method" placeholder="Enter Method" @keypress="onkeyPress('method')"></td>
                                                                </tr>  
                                                            </tbody>

                                                        </table>
                                                    </div>

                                                    <div class="details_test" v-else-if="this.form && Array.isArray(this.form.report_items) && this.form.report_items.length > 0 && form.report_type == 'text'">
                                                        <div class="row" v-for="(item, index) in form.report_items" :key="index">
                                                            <div class="col-md-6">
                                                                <div class="mb-1">
                                                                    <div class="form-group">
                                                                        <label for="test_description">Details About Test</label>
                                                                        <textarea class="form-control border" v-model="item.test_description" placeholder="Describe about test"></textarea>
                                                                    </div>
                                                                    <div class="invalid-feedback" v-if="errors.test_description">
                                                                        {{errors.test_description[0]}}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="item_area" v-else>
                                            <div class="row">      
                                                
                                                <div class="col-md-12">
                                                    <!-- category-wise checkboxes (render only when test_options has items) -->
                                                    <div v-if="form.ptest_items && form.ptest_items.length" class="mt-3">
                                                        <div class="row">
                                                        <div
                                                            class="col-md-4 mb-3"
                                                            v-for="(tests, category) in groupedTests"
                                                            :key="category"
                                                        >
                                                            <!-- Category Title -->
                                                            <div class="fw-bold mb-2 border-bottom pb-1">{{ category }}</div>

                                                            <!-- Test List -->
                                                            <ul class="list-unstyled ps-2 mb-0">
                                                            <li
                                                                v-for="test in tests"
                                                                :key="test.test_id"
                                                                class="d-flex align-items-center mb-1"
                                                            >
                                                                <input
                                                                class="form-check-input me-2"
                                                                type="checkbox"
                                                                :id="'test-' + test.test_id"
                                                                :value="test.test_id"
                                                                v-model="pform.test_ids"
                                                                @input="checkSameCategoryItem($event)"
                                                                />
                                                                <label
                                                                class="form-check-label cursor-pointer"
                                                                :for="'test-' + test.test_id"
                                                                >
                                                                {{ test.name }}
                                                                </label>
                                                            </li>
                                                            </ul>
                                                        </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                
                                                <div class="col-md-6">
                                                    <div class="row">
                                                        <div class="col-md-5">
                                                            <div class="mb-1">
                                                                <div class="form-group">
                                                                    <Multiselect 
                                                                        class="form-control border" 
                                                                        mode="single"
                                                                        v-model="pform.test_category_id"
                                                                        placeholder="Select Test Category"  
                                                                        :searchable="true" 
                                                                        :filter-results="true"
                                                                        :options="diagnosis_category_options"
                                                                        :classes="multiclasses"
                                                                        :close-on-select="true" 
                                                                        :min-chars="1"
                                                                        :resolve-on-load="false"
                                                                        :create-option="false"
                                                                        :disabled="true"
                                                                        @change="changeDiagnosisCategory($event)"
                                                                        v-if="renderOptionComponent"
                                                                    />                                               
                                                                    <div class="invalid-feedback" v-if="errors.test_category_id">
                                                                        {{errors.test_category_id[0]}}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>   
                                                        <!-- <div class="col-md-6">
                                                            <div class="mb-1">
                                                                <div class="form-group">
                                                                    <Multiselect 
                                                                        class="form-control border" 
                                                                        mode="tags"
                                                                        v-model="pform.test_ids"
                                                                        placeholder="Select Test"  
                                                                        :searchable="true" 
                                                                        :filter-results="true"
                                                                        :options="test_options"
                                                                        :classes="multiclasses"
                                                                        :close-on-select="true" 
                                                                        :min-chars="1"
                                                                        :resolve-on-load="false"
                                                                        :create-option="false"
                                                                        v-if="renderOptionComponent"
                                                                    />                                               
                                                                    <div class="invalid-feedback" v-if="errors.test_id">
                                                                        {{errors.test_id[0]}}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div> -->
                                                        
                                                        <div class="col-md-4" v-if="pform.test_ids.length > 0">
                                                            <div class="mb-1">
                                                                <div class="form-check mt-2">
                                                                    <input type="checkbox" class="form-check-input border" v-model="pform.method_column" true-value="1" false-value="0" /> Include Method Column                                           
                                                                    <div class="invalid-feedback" v-if="errors.method_column">
                                                                        {{errors.method_column[0]}}
                                                                    </div>
                                                                </div>  
                                                            </div>
                                                        </div>
                                                        <div class="col-md-3" v-if="pform.test_ids.length > 1">
                                                            <div class="mb-1">
                                                                <div class="form-group">
                                                                    <input type="text" class="form-control border" v-model="pform.specimen" placeholder="Custom Specimen" @keypress="onkeyPress('specimen')">                                              
                                                                    <div class="invalid-feedback" v-if="errors.specimen">
                                                                        {{errors.specimen[0]}}
                                                                    </div>
                                                                </div>  
                                                            </div>
                                                        </div>
                                                        <div class="col-md-12" v-if="pform.test_ids.length > 1">
                                                            <div class="mb-1">
                                                                <div class="form-group">
                                                                    <textarea class="form-control border" v-model="pform.exm_machine_info" placeholder="Enter Machine Info" @keypress="onkeyPress('exm_machine_info')"> </textarea>                                             
                                                                    <div class="invalid-feedback" v-if="errors.exm_machine_info">
                                                                        {{errors.exm_machine_info[0]}}
                                                                    </div>
                                                                </div>  
                                                            </div>  
                                                        </div>
                                                    </div>
                                                </div> 

                                                <!-- <div class="col-md-3" v-if="pform.test_ids.length > 1">
                                                    <div class="mb-1">
                                                        <div class="form-group">
                                                            <Multiselect 
                                                                class="form-control border" 
                                                                mode="single"
                                                                v-model="pform.tester_by"
                                                                placeholder="Select Pathologist/Radiologist"  
                                                                :searchable="true" 
                                                                :filter-results="true"
                                                                :options="doctor_options"
                                                                :classes="multiclasses"
                                                                :close-on-select="true" 
                                                                :min-chars="1"
                                                                :resolve-on-load="false"
                                                                :create-option="true" 
                                                                @change="changeDiagnosisTester($event)"
                                                                v-if="renderOptionComponent"
                                                            />                                               
                                                            <div class="invalid-feedback" v-if="errors.tester_by">
                                                                {{errors.tester_by[0]}}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div> -->

                                                <div class="col-md-3" v-if="pform.test_ids.length > 1">
                                                    <div class="row">
                                                        <div class="col-md-12">
                                                            <div class="mb-1">
                                                                <div class="form-group">
                                                                    <div class="form-check">
                                                                        <input
                                                                            class="form-check-input"
                                                                            type="checkbox"
                                                                            id="mannual_pathologist"
                                                                            v-model="mannual_pathologist"
                                                                            @input="changeMannualTester"
                                                                        />
                                                                        <label class="form-check-label" for="mannual_pathologist" style="font-weight: 600;">
                                                                            Add Mannual Pathologist/Radiologist
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="row">
                                                        <div class="col-md-12">
                                                            <div class="mb-1">
                                                                <div class="form-group" v-if="mannual_pathologist">
                                                                    <input type="hidden" class="form-control border" v-model="pform.tester_by">
                                                                    <input type="text" class="form-control border" v-model="pform.tester_by_name" placeholder="Enter Pathologist/Radiologist Name" @keypress="onkeyPress('tester_by_name')">                                        
                                                                    <div class="invalid-feedback" v-if="errors.tester_by_name">
                                                                        {{errors.tester_by_name[0]}}
                                                                    </div>
                                                                </div>
                                                                <div class="form-group" v-else>
                                                                    <Multiselect 
                                                                        class="form-control border" 
                                                                        mode="single"
                                                                        v-model="pform.tester_by"
                                                                        placeholder="Select Pathologist/Radiologist"  
                                                                        :searchable="true" 
                                                                        :filter-results="true"
                                                                        :options="doctor_options"
                                                                        :classes="multiclasses"
                                                                        :close-on-select="true" 
                                                                        :min-chars="1"
                                                                        :resolve-on-load="false"
                                                                        :create-option="true" 
                                                                        @change="changeDiagnosisTester($event)"
                                                                        v-if="renderOptionComponent"
                                                                    />                                               
                                                                    <div class="invalid-feedback" v-if="errors.tester_by">
                                                                        {{errors.tester_by[0]}}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-12" v-if="mannual_pathologist">
                                                            <div class="mb-1">
                                                                <div class="form-group">
                                                                    <input type="text" class="form-control border" v-model="pform.tester_specialist" placeholder="Enter Pathologist/Radiologist Speciality" @keypress="onkeyPress('tester_specialist')">
                                                                    <div class="invalid-feedback" v-if="errors.tester_specialist">
                                                                        {{errors.tester_specialist[0]}} 
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-12" v-if="mannual_pathologist">
                                                            <div class="mb-1">
                                                                <div class="form-group">
                                                                    <input type="text" class="form-control border" v-model="pform.tester_qualification" placeholder="Enter Pathologist/Radiologist Qualification" @keypress="onkeyPress('tester_qualification')">
                                                                    <div class="invalid-feedback" v-if="errors.tester_qualification">
                                                                        {{errors.tester_qualification[0]}} 
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="col-md-3" v-if="pform.test_ids.length > 1">
                                                    <div class="row">
                                                        <div class="col-md-12">
                                                            <div class="mb-1">
                                                                <div class="form-group">
                                                                    <div class="form-check">
                                                                        <input
                                                                            class="form-check-input"
                                                                            type="checkbox"
                                                                            id="mannual_medical_officer"
                                                                            v-model="mannual_medical_officer"
                                                                            @input="changeMannualMedicalOfficer"
                                                                        />
                                                                        <label class="form-check-label" for="mannual_medical_officer" style="font-weight: 600;">
                                                                            Add Mannual Medical Officer
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="row" v-if="mannual_medical_officer">
                                                        <div class="col-md-12">
                                                            <div class="mb-1">
                                                                <div class="form-group">
                                                                    <input type="text" class="form-control border" v-model="pform.medical_officer_by_name" :readonly="!mannual_medical_officer" placeholder="Enter Name" @keypress="onkeyPress('medical_officer_by_name')">                                        
                                                                    <div class="invalid-feedback" v-if="errors.medical_officer_by_name">
                                                                        {{errors.medical_officer_by_name[0]}}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-12">
                                                            <div class="mb-1">
                                                                <div class="form-group">
                                                                    <input type="text" class="form-control border" v-model="pform.medical_officer_qualification" :readonly="!mannual_medical_officer" placeholder="Enter Qualicafication" @keypress="onkeyPress('medical_officer_qualification')">
                                                                    <div class="invalid-feedback" v-if="errors.medical_officer_qualification">
                                                                        {{errors.medical_officer_qualification[0]}} 
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-12">
                                                            <div class="mb-1">
                                                                <div class="form-group">
                                                                    <input type="text" class="form-control border" v-model="pform.medical_officer_designation" :readonly="!mannual_medical_officer" placeholder="Enter Designation with Department" @keypress="onkeyPress('medical_officer_designation')">
                                                                    <div class="invalid-feedback" v-if="errors.medical_officer_designation">
                                                                        {{errors.medical_officer_designation[0]}} 
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <hr>

                                <div class="row">
                                    <div class="col-md-4"></div>
                                    <!-- <div class="col-md-4" style="border-top: 1px solid #e0e0e0;"> -->
                                    <div class="col-md-4">
                                        <div class="action_btn" style="text-align: center;">
                                            <!-- <button type="button" class="btn btn-sm btn-danger" id="reset" @click="toggleModal()" style="margin-right: 10px;">
                                                RESET
                                            </button> -->

                                            <button v-if="form_type == 'receive_print'" type="button" class="btn btn-sm btn-success" id="print_and_receive" @click="printTestReport" style="margin-right: 10px;">
                                                Print Report
                                            </button>

                                            <button v-if="form_type == 'generate'" type="button" class="btn btn-sm btn-info" id="invoice-preview" @click="reportPreviewModal" style="margin-right: 10px;">
                                                Report Preview
                                            </button>

                                            <button v-if="form_type == 'generate'" type="button" class="btn btn-sm btn-primary " :disabled="disabled" @click.prevent="submitForm()">
                                                <span v-show="isSubmit">
                                                    <i class="fas fa-spinner fa-spin" ></i>
                                                </span> Generate
                                            </button> 
                                        </div>
                                    </div>

                                    <div class="col-md-4"></div>
                                </div>
                            </form>

                            <div class="tab-pane show active" v-if="loading">
                                <div class="row"> 
                                    <div class="col-md-5">  
                                    </div>
                                    <div class=" col-md-2"> 
                                        <img src="../../../assets/image/loading.gif" alt="Loading..." style="width:130px">
                                    </div>
                                    <div class="col-md-5">  
                                    </div>
                                </div>
                            </div> 
                        </div>
                    </div>
                </div>
            </div> 


            <!-- preview and Print Modal   -->
            <Modal @close="reportPreviewModal()" :modalActive="reportPreviewModalActive">
                <div class="modal-content scrollbar-width-thin report-modal">
                    <div class="modal-header">
                    <h5>Test Report</h5>
                    <button @click="reportPreviewModal()" type="button" class="btn btn-danger">
                        X
                    </button>
                    </div>
                    <div class="modal-body inv-perview">
                        <div id="invoice-billing" class="invoice-billing">
                            <div id="top">
                                <!-- <div class="row">
                                    <div class="col-md-2 col-xs-2">
                                        <img :src="this.siteLogo" alt="Logo" class="report-logo" />
                                    </div>
                                    <div class="col-md-10 col-xs-10">
                                        <p class="text-right" style="margin-bottom: 2px;">{{ this.prescriptionAddress }}</p>
                                        <p class="text-right" style="margin-bottom: 2px;"> Mobile: {{ this.prescriptionPhone }}</p> 
                                        <p class="text-right" style="margin-bottom: 2px;"> Email: {{ this.prescriptionEmail }}</p> 
                                        <p class="text-right" style="margin-bottom: 2px;"> Web: {{ this.prescriptionWeb }}</p> 
                                        <p class="text-right" style="margin-bottom: 2px;"> Hotline: {{ this.prescriptionHotLine }}</p> 
                                        <h2 class="text-right" style="font-size: 20px">{{ this.prescriptionHospitalName }}</h2>
                                        <p class="text-right" style="color: red;">ISO 9001:2025 Certified</p>
                                    </div>
                                </div> -->
                                <div class="row">
                                    <div class="col-md-3 col-xs-3">
                                        <BarcodeGenerator
                                            :value="form.bill_no"
                                            :format="'CODE128'"
                                            :lineColor="'black'"
                                            :height="22"
                                            :width="1.7"
                                            :elementTag="'img'"
                                            :textPosition="18"
                                            :fontSize="11"
                                            :displayValue="true"
                                            v-if="renderBarcodeComponent"
                                        />
                                    </div>
                                    <div class="col-md-6 col-xs-6" style="text-align: center;">
                                        <h3 class="category-title" style="text-transform: uppercase;"> {{ preview_data.category_name + ' Report' }} </h3>
                                    </div>
                                    <div class="col-md-3 col-xs-3" style="text-align: right;">
                                        <BarcodeGenerator
                                            :value="form.bill_no"
                                            :format="'CODE128'"
                                            :lineColor="'black'"
                                            :height="22"
                                            :width="1.7"
                                            :elementTag="'img'"
                                            :textPosition="18"
                                            :fontSize="11"
                                            :displayValue="true"
                                            v-if="renderBarcodeComponent"
                                        />
                                    </div>
                                </div>
                            </div>
                            <!--End InvoiceTop-->
                            <div id="mid">
                                <div class="info">
                                    <table style="width: 100%;">
                                        <tr>
                                            <td>ID No</td>
                                            <td>:</td>
                                            <td>{{ form.bill_no }}</td>
                                            <td colspan="3" style="text-align: right;">Bill on: {{ form.bill_date }} Print on: {{  new Date().toLocaleDateString() }} Deliv. on: {{ form.bill_date }}</td>
                                        </tr>
                                        <tr>
                                            <td>Name</td>
                                            <td>:</td>
                                            <td id="pname">{{ form.patient_name }}</td>
                                            <td></td>
                                            <td></td>
                                            <td style="text-align: right;"><span>Age: {{ form.patient_age }}</span> <span>Gender: {{ form.patient_gender }}</span></td>
                                        </tr>
                                        <tr>
                                            <td>Refd By</td>
                                            <td>:</td>
                                            <td colspan="4">{{ form.reference_person_name }}</td>
                                        </tr>
                                        <tr>
                                            <td>Specimen</td>
                                            <td>:</td>
                                            <td> {{ form.specimen }} </td>
                                            <td></td>
                                            <td style="text-align: right;"><span>Collected On: {{ preview_data.sample_collected_datetime }}</span></td>
                                            <td style="text-align: right;"><span>Received on: {{ preview_data.test_complete_datetime ?? new Date().toLocaleDateString() }}</span> </td>
                                        </tr>
                                    </table>
                                </div>
                            
                            </div>
                            <!--End Invoice Mid-->
                            <div id="bot">
                                <div class="machine_info" style="text-align: center;">
                                    <h6>{{ form.exm_machine_info }}</h6>
                                </div>
                                <div class="items-info">
                                    <table style="width: 100% !important; border: none;" v-if="this.form.report_type == 'parameter'">
                                        <thead>
                                            <tr>
                                                <td>Parameter</td>
                                                <td>Result</td>
                                                <td>Reference Value</td>
                                                <td>Method</td>
                                            </tr>
                                        </thead>

                                        <tbody>
                                            <tr v-for="(item, i) in form.report_items" :key="i">
                                                <td> {{ item.parameter_name }} </td>
                                                <td> <strong>{{ item.result }}</strong> {{ item.unit_name }}</td>
                                                <td> {{ item.reference_value }} </td>
                                                <td> {{ item.method }} </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <!--End Table-->
                                    <div v-else-if="this.form.report_type == 'text'">
                                        <div class="row" v-for="(item, index) in form.report_items" :key="index">
                                            <div class="col-md-12">
                                                <h4 style="border-bottom: 2px solid #000;">{{ report_data.name + ' Details:' }}</h4>
                                                <p>{{ item.test_description }}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="fixed-div">
                                    <div class="status-signatures">
                                        <div class="row">
                                            <div class="col-md-8 col-xs-8">
                                                <div class="signature-info" v-if="form.medical_officer_by_name">
                                                    <h6>{{ form.medical_officer_by_name }}</h6>
                                                    <p>{{ form.medical_officer_qualification }}</p>
                                                    <p>{{ form.medical_officer_designation }}</p>
                                                    <p>{{ this.retailShopName + ' ' + this.retailSmallText }}</p>
                                                </div>
                                            </div>

                                            <div class="col-md-4 col-xs-4">
                                                <div class="status-info" v-if="form.tester_by_name">
                                                    <h6>{{ form.tester_by_name }}</h6> 
                                                    <p>{{ (tester_data) ? tester_data.qualification : "" }}</p>
                                                    <p>{{ (tester_data) ? tester_data.specialist : "" }}</p>
                                                    <p>{{ this.retailShopName + ' ' + this.retailSmallText }}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                            <!--End InvoiceBot-->
                        </div>
                        <!--End Invoice-->
                    </div>
                    <div class="modal-footer">
                        <div class="col-md-12">
                            <div class="row button-list pt-2">
                            <div class="col-md-4" style="padding: 0 5px">
                                <div class="d-grid">
                                <button
                                    type="button"
                                    class="btn btn-sm btn-success"
                                    @click="printInvoice('invoice-billing')"
                                >
                                    Print
                                </button>
                                </div>
                            </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal> 

            <!-- preview and Print Modal   -->
            <Modal @close="reportPrintModal()" :modalActive="reportPrintModalActive">
                <div class="modal-content scrollbar-width-thin report-modal">
                    <div class="modal-header">
                    <h5>Test Report</h5>
                    <button @click="reportPrintModal()" type="button" class="btn btn-danger">
                        X
                    </button>
                    </div>
                    <div class="modal-body inv-perview" v-if="report_data != ''">
                        <div id="print-report" class="invoice-billing">
                            <div id="top">
                                <!-- <div class="row">
                                    <div class="col-md-2 col-xs-3">
                                        <img :src="this.siteLogo" alt="Logo" class="report-logo" />
                                    </div>
                                    <div class="col-md-10 col-xs-9 top_add_info">
                                        <p class="text-right" style="margin-bottom: 2px; text-align: right;">{{ this.prescriptionAddress }}</p>
                                        <p class="text-right" style="margin-bottom: 2px; text-align: right;"> Mobile: {{ this.prescriptionPhone }}</p> 
                                        <p class="text-right" style="margin-bottom: 2px; text-align: right;"> Email: {{ this.prescriptionEmail }}</p> 
                                        <p class="text-right" style="margin-bottom: 2px; text-align: right;"> Web: {{ this.prescriptionWeb }}</p> 
                                        <p class="text-right" style="margin-bottom: 2px; text-align: right;"> Hotline: {{ this.prescriptionHotLine }}</p> 
                                        <h2 class="text-right" style="text-align: right; margin-top: 0; margin-bottom: 0;">{{ this.prescriptionHospitalName }}</h2>
                                        <p class="text-right" style="color: red; text-align: right; font-size:12px; margin-bottom: 0;">ISO 9001:2025 Certified</p>
                                    </div>
                                </div> -->
                                <div class="row">
                                    <div class="col-md-3 col-xs-3">
                                        <BarcodeGenerator
                                            :value="report_data.bill_no"
                                            :format="'CODE128'"
                                            :lineColor="'black'"
                                            :height="22"
                                            :width="1.7"
                                            :elementTag="'img'"
                                            :textPosition="18"
                                            :fontSize="11"
                                            :displayValue="true"
                                            v-if="renderBarcodeComponent"
                                        />
                                    </div>
                                    <div class="col-md-6 col-xs-6" style="text-align: center;">
                                        <h3 class="category-title" style="text-transform: uppercase;"> {{ this.report_data.category_name + ' Report' }} </h3>
                                    </div>
                                    <div class="col-md-3 col-xs-3" style="text-align: right;">
                                        <BarcodeGenerator
                                            :value="report_data.bill_no"
                                            :format="'CODE128'"
                                            :lineColor="'black'"
                                            :height="22"
                                            :width="1.7"
                                            :elementTag="'img'"
                                            :textPosition="18"
                                            :fontSize="11"
                                            :displayValue="true"
                                            v-if="renderBarcodeComponent"
                                        />
                                    </div>
                                </div>
                            </div>
                            <!--End InvoiceTop-->
                            <div id="mid" style="margin-bottom: 3px;">
                                <div class="info" style="margin-bottom: 0;">
                                    <table style="width: 100%;">
                                        <tr>
                                            <td>ID No</td>
                                            <td>:</td>
                                            <td>{{ report_data.bill_no }}</td>
                                            <td colspan="3" style="text-align: right;">Bill on: {{ report_data.bill_datetime }} Print on: {{  report_data.print_datetime }} Deliv. on: {{ report_data.delivery_datetime }}</td>
                                        </tr>
                                        <tr>
                                            <td>Name</td>
                                            <td>:</td>
                                            <td id="pname">{{ report_data.patient_name }}</td>
                                            <td></td>
                                            <td></td>
                                            <td style="text-align: right;"><span>Age: {{ report_data.patient_age }}</span>, <span> Gender: {{ report_data.patient_gender }}</span></td>
                                        </tr>
                                        <tr>
                                            <td>Refd By</td>
                                            <td>:</td>
                                            <td colspan="4">{{ report_data.reference_person_name }}</td>
                                        </tr>
                                        <tr>
                                            <td>Specimen</td>
                                            <td>:</td>
                                            <td> {{ report_data.specimen }} </td>
                                            <td></td>
                                            <td style="text-align: right;"><span>Collected On: {{ report_data.collected_datetime }}</span></td>
                                            <td style="text-align: right;"><span>Received on: {{ report_data.receive_datetime ?? new Date().toLocaleDateString() }}</span> </td>
                                        </tr>
                                    </table>
                                </div>
                            
                            </div>
                            <!--End Invoice Mid-->
                            <div id="bot">
                                <div class="machine_info" style="text-align: center;">
                                    <h6 style="margin: 2px; font-weight: 600;">{{ report_data.exm_machine_info }}</h6>
                                </div>
                                <div class="items-info" style="min-height: 300px;" v-if="report_data.test_items.length > 0">
                                    <template v-for="(item, index) in report_data.test_items" :key="index">
                                        <table style="width: 100% !important; border: none;" v-if="item.item_report.report_type == 'parameter'">
                                            <thead v-if="index == 0">
                                                <tr>
                                                    <td style="width: 30%;">Parameter</td>
                                                    <td style="width: 20%;">Result</td>
                                                    <td style="width: 40%;">Reference Value</td>
                                                    <td style="width: 10%;" v-if="pform.method_column">Method</td>
                                                </tr>
                                            </thead>

                                            <tbody>
                                                <tr>
                                                    <td colspan="4"></td>
                                                </tr>
                                                <tr v-if="report_data.test_items.length > 1">
                                                    <td> 
                                                        <h6 style="border-bottom: 1px solid #eee;">{{ item.name + ':' }}</h6>
                                                    </td>
                                                    <td colspan="3"></td> 
                                                </tr>
                                                <tr v-for="(ritem, i) in JSON.parse(item.item_report.parameters)" :key="i">
                                                    <td style="width: 30%;"> {{ ritem.parameter_name }} </td>
                                                    <td style="width: 20%;"> <strong>{{ ritem.result }}</strong> {{ ritem.unit_name }}</td>
                                                    <td style="width: 40%;"> {{ ritem.reference_value }} </td>
                                                    <td style="width: 10%;" v-if="pform.method_column"> {{ ritem.method }} </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <!--End Table-->
                                        <div v-else-if="item.item_report.report_type == 'text'">
                                            <div class="row">
                                                <div class="col-md-12">
                                                    <h4 style="border-bottom: 2px solid #000;">{{ item.name + ' Details:' }}</h4>
                                                    <p>{{ item.item_report.description }}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </template>
                                    
                                </div>

                                <div class="fixed-div" style="margin-top: 30px;">
                                    <div class="status-signatures">
                                        <div class="row">
                                            <div class="col-md-8 col-xs-8">
                                                <div class="signature-info" v-if="report_data.medical_officer_by_name">
                                                    <h6>{{ report_data.medical_officer_by_name }}</h6>
                                                    <p style="margin-bottom: 2px;">{{ report_data.medical_officer_qualification }}</p>
                                                    <p style="margin-bottom: 2px;">{{ report_data.medical_officer_designation }}</p>
                                                    <p>{{ this.retailShopName + ' ' + this.retailSmallText }}</p>
                                                </div>
                                                <div class="signature-info" v-else>
                                                    <h6>{{ report_data.created_by }}</h6>
                                                    <p style="margin-bottom: 2px;">Medical Technologist (Laboratory Medicine)</p>
                                                    <p style="margin-bottom: 2px;">In-Charge Department Of Laboratory</p>
                                                    <p>{{ this.retailShopName + ' ' + this.retailSmallText }}</p>
                                                </div>
                                            </div>

                                            <div class="col-md-4 col-xs-4">
                                                <div class="status-info" v-if="report_data.tester_by_name">
                                                    <h6>{{ report_data.tester_by_name }}</h6> 
                                                    <p style="margin-bottom: 2px;">{{ report_data.tester_qualification ?? "" }}</p>
                                                    <p style="margin-bottom: 2px;">{{ report_data.tester_specialist ?? "" }}</p>
                                                    <p>{{ this.retailShopName + ' ' + this.retailSmallText }}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                            <!--End InvoiceBot-->
                        </div>
                        <!--End Invoice-->
                    </div>
                    <div class="modal-footer">
                        <div class="col-md-12">
                            <div class="row button-list pt-2">
                            <div class="col-md-4" style="padding: 0 5px">
                                <div class="d-grid">
                                <button
                                    type="button"
                                    class="btn btn-sm btn-success"
                                    @click="printDiagnosisReport('print-report')"
                                >
                                    Print
                                </button>
                                </div>
                            </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal> 

        </div>
    </transition>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import Modal from "../../helper/Modal";
import BarcodeGenerator from "@/components/BarcodeGenerator.vue";
import Datatable from '@/components/Datatable.vue';
import Pagination from '@/components/Pagination.vue';
import { ref, onMounted } from "vue";
import Form from 'vform'
import axios from 'axios';
export default {
    name: 'Appointments',
    components: {
        Modal,
        BarcodeGenerator,
        Datatable,
        Pagination,
    },
    props:{
        language: {
          type: Object,
          default: () => {
            return {
              lengthMenu: null,
              info: null,
              zeroRecords: null, 
              search: null
            }
          },
        },
    },
    data() {
        return {
            loading: true,
            isSubmit: false,
            showModal: false,
            editMode:false,
            disabled: false,
            modalActive:false,  
            reportPreviewModalActive:false,
            reportPrintModalActive:false,       
            errors: {},
            imagePreview: '',
            btn:'SUBMIT',
            renderOptionComponent: true,
            renderBarcodeComponent: true,
            costCenterOptions: [],
            valueConsistsOf: 'BRANCH_PRIORITY',
            normalizer(node) {
                return {
                    id: node.id+'___'+node.code,
                    label: node.name,
                    children: node.children,
                }
            },
            loggedInUser: this.$store.getters.userData.user || '',
            items: [],
            gender_options: [{label:'Male', value:'male'}, {label:'Female', value:'female'}],
            report_type_options: [{label:'Parameter', value:'parameter'}, {label:'Text', value:'text'}],
            doctors: [],
            doctor_options: [],
            diagnosis_categories: [],
            diagnosis_category_options: [],
            test_items: [],
            test_options: [],
            test_name: '',
            searchTerm: '',
            arrowCounter: -1,
            searchTests: [],     
            billing_info: '',      
            preview_data: '',
            report_data: '',
            tester_data: '',
            form_type: 'generate',
            mannual_pathologist: false,
            mannual_medical_officer: false,
            prevTestIds: [], // keep last valid selection
            pform: new Form({
                test_category_id: '',
                test_ids: [],
                method_column: 0,
                specimen: '',
                exm_machine_info: '',
                tester_by: '',
                tester_by_name: '',
                tester_qualification: '',
                tester_specialist: '',
                medical_officer_by_name: '',
                medical_officer_qualification: '',
                medical_officer_designation: '',
            }),
            form: new Form({
                id: '',
                bill_no: '',
                bill_date: '',
                bill_datetime: '',
                patient_name: '',
                patient_age: '',
                patient_gender: '',
                patient_phone: '',
                reference_type: 'doctor',
                reference_person_id: '',
                reference_person_name: '',
                delivery_date: '',
                delivery_time: '05:00 PM',
                test_id: '',
                report_type: 'parameter',
                specimen: '',
                exm_machine_info: '',
                tester_by: '',
                tester_by_name: '',
                tester_qualification: '',
                tester_specialist: '',
                medical_officer_by_name: (this.$store.getters.userData.user) ? this.$store.getters.userData.user.name : '',
                medical_officer_qualification: 'Medical Technologist (Laboratory Medicine)',
                medical_officer_designation: 'In-Charge Department Of Laboratory',
                ptest_items: [],
                report_items: [],
                print_datetime: new Date().toLocaleDateString('en-US', {
                    day: '2-digit',
                    month: '2-digit',
                    year: 'numeric',
                    hour: '2-digit',
                    minute: '2-digit',
                    hour12: true
                }).replace(',', ''),
                created_by: '',

            }),       

            multiclasses: { 
                clear: '',
                clearIcon: '', 
            },

        };
    },

    created() { 
        this.fetchDiagnosisReportProcessData();
    },

    methods: { 
        forceRerender() {
            // Remove my-component from the DOM
            this.renderOptionComponent = false;
            this.renderBarcodeComponent = false;

            this.$nextTick(() => {
                // Add the component back in
                this.renderOptionComponent = true;
                this.renderBarcodeComponent = true;
            });
        },
        toggleModal: function() {
            this.modalActive = !this.modalActive;   
            if(!this.modalActive){
                this.editMode = false;
                this.btn='Create';
            } 
            this.errors = '';
            this.isSubmit = false;
        },

        onChangeReportForm: function($event) {
            this.form_type = $event.target.value;
            this.form.reset();
        },

        changeMannualTester: function() {
            this.form.tester_by = '';
            this.form.tester_by_name = '';
            this.form.tester_qualification = '';
            this.form.tester_specialist = '';
            this.pform.tester_by = '';
            this.pform.tester_by_name = '';
            this.pform.tester_qualification = '';
            this.pform.tester_specialist = '';
        },

        changeMannualMedicalOfficer: function() {
            this.form.medical_officer_by_name = !this.mannual_medical_officer ? '' : this.$store.getters.userData.user.name;
            // this.form.medical_officer_qualification = !this.mannual_medical_officer ? '' : 'Medical Technologist (Laboratory Medicine)';
            // this.form.medical_officer_designation = !this.mannual_medical_officer ? '' : 'In-Charge Department Of Laboratory';
            this.pform.medical_officer_by_name = '';
            this.pform.medical_officer_qualification = '';
            this.pform.medical_officer_designation = '';
        },

        reportPreviewModal: function() {
            this.forceRerender();
            if(this.form.test_id != '') {
                let test_item = this.form.ptest_items.find((item) => item.test_id == this.form.test_id);
                this.preview_data = test_item;
            }

            if(this.form.tester_by != '') {
                let doctor_item = this.doctors.find((item) => item.id == this.form.tester_by);
                this.tester_data = doctor_item;
            }else{
                this.tester_data = {
                    qualification: this.form.tester_qualification,
                    specialist: this.form.tester_specialist,
                };
            }

            console.log(this.tester_data);
            this.reportPreviewModalActive = !this.reportPreviewModalActive;

        },

        reportPrintModal: function() {
            this.reportPrintModalActive = !this.reportPrintModalActive;
            this.forceRerender();
        },

        checkSameCategoryItem(selectedIds) {
            // normalize to array (supports being called with event or new array)
            const ids = Array.isArray(selectedIds) ? selectedIds : (this.pform.test_ids || []);

            // if nothing selected -> ok, update prev and return
            if (!ids.length) {
                this.prevTestIds = [];
                this.pform.test_category_id = null;
                return;
            }

            // gather category ids for the selected tests
            const categories = new Set();
            let firstCategoryId = null;
            for (const id of ids) {
                // find by matching types loosely (in case test_id is string/number)
                const item = this.form.ptest_items.find(it => String(it.test_id) === String(id));
                if (item && item.category_id != null) {
                    categories.add(String(item.category_id));
                    if (!firstCategoryId) firstCategoryId = item.category_id;
                }
            }

            // if more than one category selected -> reject and restore previous selection
            if (categories.size > 1) {
                this.$toast.error('Please select tests from the same category.');
                // restore previous valid selection
                this.$nextTick(() => { 
                    // assign a copy to trigger reactivity
                    this.pform.test_ids = Array.isArray(this.prevTestIds) ? [...this.prevTestIds] : [];
                    // also restore category to prev selection's category (or null)
                    if (this.prevTestIds.length) {
                    const prevFirst = this.form.ptest_items.find(it => String(it.test_id) === String(this.prevTestIds[0]));
                    this.pform.test_category_id = prevFirst ? prevFirst.category_id : null;
                    } else {
                    this.pform.test_category_id = null;
                    }
                });
                return;
            }


            // valid selection: save as previous
            this.prevTestIds = [...ids];
            this.pform.test_category_id = firstCategoryId;
        },

        printTestReport: function() {
            let category_id = this.pform.test_category_id;
            let test_ids = this.pform.test_ids;
            let category_name = this.diagnosis_categories.find((item) => item.id == category_id).name;

            if(category_id == '' || test_ids.length == 0) {
                this.$toast.error('Please select test category and test');
                return;
            }
            let ptest_items = this.form.ptest_items.filter(item => item.category_id === category_id && test_ids.includes(item.test_id));
            if (ptest_items.some(item => item.item_report === "")) {
                this.$toast.error('Report not found');
                return;
            }


            // collect unique, non-empty specimens from selected ptest_items and store into first item's specimen
            let specimens = ptest_items
                .map(pi => (pi.item_report && pi.item_report.specimen) ? pi.item_report.specimen.trim() : '')
                .filter(s => s); // remove empty

            // unique
            // specimens = specimens.filter((v, i, a) => a.indexOf(v) === i);
            let lowerSeen = new Set();
            specimens = specimens.filter(s => {
                let lower = s.toLowerCase();
                if (lowerSeen.has(lower)) return false;
                lowerSeen.add(lower);
                return true;
            });
            // capitalize each unique specimen
            specimens = specimens.map(s =>
                s.charAt(0).toUpperCase() + s.slice(1).toLowerCase()
            );

            let specimen_data = specimens.length ? specimens.join(', ') : (ptest_items[0] && ptest_items[0].item_report ? ptest_items[0].item_report.specimen : '');

            let report_data = {
                    bill_no: this.form.bill_no,
                    bill_date: this.form.bill_date,
                    bill_datetime: this.form.bill_datetime,
                    print_datetime: this.form.print_datetime,
                    patient_name: this.form.patient_name,
                    patient_age: this.form.patient_age,
                    patient_gender: this.form.patient_gender,
                    patient_phone: this.form.patient_phone,
                    reference_type: this.form.reference_type,
                    reference_person_id: this.form.reference_person_id,
                    reference_person_name: this.form.reference_person_name,
                    category_name: category_name,
                    delivery_datetime: ptest_items[0].delivery_datetime ?? this.form.delivery_date+' '+this.form.delivery_time,
                    collected_datetime: ptest_items[0].sample_collected_datetime,
                    receive_datetime: ptest_items[0].test_complete_datetime,
                    test_items: ptest_items,
                    created_by: this.form.created_by,
                    specimen: (this.pform.specimen != '') ? this.pform.specimen : specimen_data,
                    exm_machine_info: (this.pform.exm_machine_info != '') ? this.pform.exm_machine_info : ptest_items[0].item_report.exm_machine_info,
                    tester_by_name: (this.pform.tester_by_name != '') ? this.pform.tester_by_name : ptest_items[0].item_report.tester_name,
                    tester_qualification: (this.pform.tester_qualification != '') ? this.pform.tester_qualification : (ptest_items[0].item_report.testers) ? ptest_items[0].item_report.testers.qualification : ptest_items[0].item_report.tester_qualification,
                    tester_specialist: (this.pform.tester_specialist != '') ? this.pform.tester_specialist : (ptest_items[0].item_report.testers) ? ptest_items[0].item_report.testers.specialist : ptest_items[0].item_report.tester_specialist,
                    medical_officer_by_name: (this.pform.medical_officer_by_name != '') ? this.pform.medical_officer_by_name : (ptest_items[0].item_report?.medical_officer_by_name ?? this.form.created_by),
                    medical_officer_qualification: (this.pform.medical_officer_qualification != '') ? this.pform.medical_officer_qualification : (ptest_items[0].item_report?.medical_officer_qualification ?? 'Medical Technologist (Laboratory Medicine)'),
                    medical_officer_designation: (this.pform.medical_officer_designation != '') ? this.pform.medical_officer_designation : (ptest_items[0].item_report?.medical_officer_designation ?? 'In-Charge Department Of Laboratory'),
            };
            console.log("report_data", report_data);
            this.report_data = report_data;
            this.reportPrintModalActive = !this.reportPrintModalActive;
            setTimeout(() => { 
                this.printDiagnosisReport('print-report');
            }, 2000);

        },

        fetchDiagnosisReportProcessData() {
            axios.get(this.apiUrl+'/hm/diagnosis_billings/report-generate-process-create', this.headerjson)
            .then((res) => {
                let data = res.data.data;
                this.test_items = data.diagnosis_tests;
                this.doctors = data.doctors;
                this.doctor_options = data.doctors.map((item) => {
                    return {label:item.first_name + ' ' + item.last_name, value:item.id}
                });
                this.diagnosis_categories = data.diagnosis_categories;
                this.diagnosis_category_options = data.diagnosis_categories.map((item) => {
                    return {label:item.name, value:item.id}
                });
            })
            .catch((err) => { 
                this.$toast.error(err.response.data.message);
            }).finally((ress) => {
                this.loading = false;
            });
        },
        
        fetchCostCenters()
        {
            axios.get(this.apiUrl+'/cost_centers', this.headerjson)
            .then((res) => {
                this.costCenterOptions = res.data.data.cost_center_options;
            })
            .catch((err) => { 
                this.$toast.error(err.response.data.message);
            });
        },

        fetchDiagnosisBillingInvoice() {
            this.test_options = [];
            this.form.reset();
            this.pform.reset();
            this.forceRerender();
            if(this.searchTerm != '') {
                let request = {
                    invoice_no: this.searchTerm,
                };
                if(this.form_type == 'receive_print') {
                    let postEvent = axios.post(this.apiUrl+'/hm/diagnosis_billings/fetch-diagnosis-report-print-receive', request, this.headerjson);
                    postEvent.then((res) => {
                        this.form.fill(res.data.data.billing_info);
                        if(!/^\d+$/.test(res.data.data.billing_info.reference_person_id)) {
                            this.doctor_options.push({label: res.data.data.billing_info.reference_person_name, value: res.data.data.billing_info.reference_person_name});
                        }

                        console.log(res.data.data.billing_info.ptest_items);
                        this.test_options = res.data.data.billing_info.ptest_items.map((item) => {
                            return {label:item.name, value:item.test_id}
                        });
                        this.forceRerender();                    
                    })
                    .catch((err) => { 
                        this.$toast.error(err.response.data.message);
                    }).finally((ress) => {
                        this.searchTerm = '';
                    });
                }else {
                    let postEvent = axios.post(this.apiUrl+'/hm/diagnosis_billings/fetch-diagnosis-report-generate-bill', request, this.headerjson);
                    postEvent.then((res) => {

                        this.form.fill(res.data.data.billing_info);
                        this.form.report_type = 'parameter';
                        if(!/^\d+$/.test(res.data.data.billing_info.reference_person_id)) {
                            this.doctor_options.push({label: res.data.data.billing_info.reference_person_name, value: res.data.data.billing_info.reference_person_name});
                        }
                        this.test_options = res.data.data.billing_info.ptest_items.map((item) => {
                            return {label:item.name, value:item.test_id}
                        });
                        this.forceRerender();     

                        /** For manual tester add */
                        this.form.tester_by = res.data.data.billing_info.tester_by ?? '';
                        this.form.tester_by_name = res.data.data.billing_info.tester_by_name ?? '';
                        this.form.tester_specialist = res.data.data.billing_info.tester_specialist ?? '';
                        this.form.tester_qualification = res.data.data.billing_info.tester_qualification ?? '';
                        
                        /** For Mannual Officer Add */
                        this.form.medical_officer_by_name = this.$store.getters.userData.user.name;
                        this.form.medical_officer_qualification = 'Medical Technologist (Laboratory Medicine)';
                        this.form.medical_officer_designation = 'In-Charge Department Of Laboratory';
                        this.pform.medical_officer_by_name = this.$store.getters.userData.user.name;
                        this.pform.medical_officer_qualification = 'Medical Technologist (Laboratory Medicine)';
                        this.pform.medical_officer_designation = 'In-Charge Department Of Laboratory';

                        
                    })
                    .catch((err) => { 
                        this.$toast.error(err.response.data.message);
                    }).finally((ress) => {
                        this.searchTerm = '';
                    });
                }
            }
        },


        changeDiagnosisCategory(selectedValue) {
            this.pform.test_category_id = selectedValue;
            this.pform.test_ids = [];

            if(selectedValue != null) {
                let test_items = this.form.ptest_items.filter(item => item.category_id == selectedValue);
                this.test_options = test_items.map((item) => {
                    return {label:item.name, value:item.test_id}
                });
            }else{
                this.test_options = [];
            }
        },  

        inputChanged(event) {

            if (event.code == "ArrowUp" || event.code == "ArrowDown")
                return;
            if (event.code == "Enter")
                return;
            if(this.searchTerm == '') 
                return;

            this.fetchDiagnosisBillingInvoice();

        },

        changeTestItem(selectedValue) {
            let testData = this.form.ptest_items.find(item => item.test_id == selectedValue);
            this.form.exm_machine_info = testData ? testData.cat_machine_info : '';
            this.form.report_items = [];
            if (!Array.isArray(this.form.report_items)) {
                this.form.report_items = [];
            }

            if(testData && this.form.report_type == 'parameter') {
                let testChildren = testData.childrens;
                if(testChildren.length > 0) {
                    testChildren.forEach((item) => {
                        this.form.report_items.push({
                            test_item_id: testData.id,
                            test_id: testData.test_id,
                            parameter_id: item.id,
                            parameter_name: item.name,
                            result: "",
                            unit_id: item.unit_id,
                            unit_name: item.unit_name,
                            reference_value: item.reference_value,
                            method: "",
                            test_description: "",
                        });
                    });
                }else{
                    this.form.report_items.push({
                        test_item_id: testData.id,
                        test_id: testData.test_id,
                        parameter_id: testData.test_id,
                        parameter_name: testData.name,
                        result: "",
                        unit_id: testData.unit_id,
                        unit_name: testData.unit_name,
                        reference_value: testData.reference_value,
                        method: "",
                        test_description: "",
                    });
                }
            }else if(testData && this.form.report_type == 'text') {
                
                this.form.report_items.push({
                    test_item_id: testData.id,
                    test_id: testData.test_id,
                    parameter_id: "",
                    parameter_name: "",
                    result: "",
                    unit_id: "",
                    unit_name: "",
                    reference_value: "",
                    method: "",
                    test_description: "",
                });
            }
        },

        changeReportType(selectedValue) {
            const selectedOption = this.report_type_options.find(option => option.value === selectedValue);
            const selectedText = selectedOption ? selectedOption.label : null;
            this.form.report_type = selectedValue;
            let testData = this.form.ptest_items.find(item => item.test_id == this.form.test_id);
            this.form.report_items = [];
            if (!Array.isArray(this.form.report_items)) {
                this.form.report_items = [];
            }

            if(testData && this.form.report_type == 'parameter') {
                let testChildren = testData.childrens;
                if(testChildren.length > 0) {
                    testChildren.forEach((item) => {
                        this.form.report_items.push({
                            test_item_id: testData.id,
                            test_id: testData.test_id,
                            parameter_id: item.id,
                            parameter_name: item.name,
                            result: "",
                            unit_id: item.unit_id,
                            unit_name: item.unit_name,
                            reference_value: item.reference_value,
                            method: "",
                            test_description: "",
                        });
                    });
                }else{
                    this.form.report_items.push({
                        test_item_id: testData.id,
                        test_id: testData.test_id,
                        parameter_id: testData.test_id,
                        parameter_name: testData.name,
                        result: "",
                        unit_id: testData.unit_id,
                        unit_name: testData.unit_name,
                        reference_value: testData.reference_value,
                        method: "",
                        test_description: "",
                    });
                }
            }else if(testData && this.form.report_type == 'text') {
                
                this.form.report_items.push({
                    test_item_id: testData.id,
                    test_id: testData.test_id,
                    parameter_id: "",
                    parameter_name: "",
                    result: "",
                    unit_id: "",
                    unit_name: "",
                    reference_value: "",
                    method: "",
                    test_description: "",
                });
            }
        },

        changeDiagnosisTester(selectedValue) {
            const selectedOption = this.doctor_options.find(option => option.value === selectedValue);
            const selectedText = selectedOption ? selectedOption.label : null;
            this.form.tester_by_name = selectedText;

            let tester_info = this.doctors.find(item => item.id == selectedValue);
            if(!tester_info) {
                this.pform.tester_by_name = '';
                this.pform.tester_qualification = '';
                this.pform.tester_specialist = '';
            }else{
                this.pform.tester_by_name = tester_info.first_name + ' ' + tester_info.last_name;
                this.pform.tester_qualification = tester_info.qualification;
                this.pform.tester_specialist = tester_info.specialist;
            }
        },

        setTestComplete(index, status) {
            let datetime_val = new Date().toLocaleDateString('en-US', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit',
                hour12: false
            }).replace(',', '');

            let curr_datetime = "";
            let msg = "";
            if(status == 'complete') {
                curr_datetime = "";
                msg = "You want to set this test not complete?";
            }else{
                curr_datetime = datetime_val;
                msg = "You want to set this test is complete?";
            }

            this.$swal({
                title: 'Are you sure?',
                text: msg, 
                showCancelButton: true,
                confirmButtonCategory: '#3085d6',
                cancelButtonCategory: '#d33',
                confirmButtonText: 'Confirm!'
            }).then((result) => { 
                if (result.value) { 
                    this.form.ptest_items[index].test_complete_datetime = curr_datetime;
                    this.$toast.success("Test status updated successfully.");
                }else{
                    // this.$toast.error(`Hey! I'm here`);
                    // this.$toast.warning(`Hey! I'm here`);
                    // this.$toast.info(`Hey! I'm here`)
                }
            });
        },

        addReagentItem: function(index) {
            this.form.ptest_items[index].reagent_items.push({
                reagent_id: '',
                name: '',
                qty: 1,
                price: '',
            });
        },

        removeReagentItem: function(index, i) {
            this.$swal({
                title: 'Are you sure?',
                text: "You want to remove this item!", 
                showCancelButton: true,
                confirmButtonCategory: '#3085d6',
                cancelButtonCategory: '#d33',
                confirmButtonText: 'Remove'
            }).then((result) => { 
                if (result.value) {
                    this.form.ptest_items[index].reagent_items.splice(i, 1);
                }else{
                    // this.$toast.error(`Hey! I'm here`);
                    // this.$toast.warning(`Hey! I'm here`);
                    // this.$toast.info(`Hey! I'm here`)
                }
            });
        },

        checkExistsReagentItem(index, i, newProductId) {
            const exists = this.form.ptest_items[index].reagent_items.some((item, r) =>
                r !== i && item.reagent_id === newProductId
            );

            if (exists) {
                this.form.ptest_items[index].reagent_items.splice(i, 1); // Remove the current item
                this.forceRerender();
                this.form.ptest_items[index].reagent_items.push({
                    reagent_id: '',
                    name: '',
                    qty: 1,
                    price: '',
                });
                this.$toast.error("This item already exists in the list.");
                return;
            }else {
                const selectedProduct = this.products.find(item => item.product_id === newProductId);
                if (selectedProduct) {
                    this.form.ptest_items[index].reagent_items[i].name = selectedProduct.product.product_name;
                    this.form.ptest_items[index].reagent_items[i].price = selectedProduct.product.cost_price;
                } else {
                    this.form.ptest_items[index].reagent_items[i].name = '';
                    this.form.ptest_items[index].reagent_items[i].price = '';
                }
            }
        },

        selectTests(item) { 
            this.test_name = item.name;
            this.searchTerm = item.name;
        }, 

        setResult(item) { 
            this.test_name = item.name;
            this.searchTerm = item.name;
            this.getTestInvoice();
            this.searchTests = [];
        }, 

            // For Check Product List
        checkExistsTest(array_data, test_name){
            let testExists = false;
            array_data.map((item) => {
                if(item.name == test_name) {
                    testExists = true;
                }
            });

            return testExists;
        },

        removeTestListItem(row_id) {
            if (this.form.ptest_items[row_id]) {
                // Get the test item ID that will be removed
                const testItemId = this.form.ptest_items[row_id].id;
                
                // For Reagent Items
                var relatedReagents = this.form.ptest_reagent_items.filter(item => item.test_ids.includes(testItemId));
                relatedReagents.forEach((reagentItem) => {
                    // Calculate the quantity to decrease based on the specific test item's reagent quantity
                    let testItemReagentQty = this.form.ptest_items[row_id].dtconfig_reagents.find(r => r.reagent_id === reagentItem.id)?.qty || 0;

                    if (testItemReagentQty > 0) {
                        // Decrease the qty of the reagent item
                        reagentItem.qty -= testItemReagentQty;
                        reagentItem.test_ids.splice(reagentItem.test_ids.indexOf(testItemId), 1);
                    }

                    // Check if any other test items use this reagent
                    const isReagentUsedByOthers = this.form.ptest_items.some(item => 
                        item.id !== testItemId && 
                        item.dtconfig_reagents.some(r => r.reagent_id === reagentItem.id)
                    );

                    // If no other test items use this reagent and the qty is zero or less, remove it
                    // if (!isReagentUsedByOthers && reagentItem.qty <= 0) {
                    if (!isReagentUsedByOthers) {
                        this.form.ptest_reagent_items.splice(this.form.ptest_reagent_items.indexOf(reagentItem), 1);
                    }
                });

                // For Staionery Items
                var releatedStationery = this.form.ptest_stequipment_items.filter(item => item.test_ids.includes(testItemId));
                releatedStationery.forEach((stationeryItem) => {
                    // Calculate the quantity to decrease based on the specific test item's reagent quantity
                    let testItemStationeryQty = this.form.ptest_items[row_id].dtconfig_stequipments.find(r => r.product_id === stationeryItem.id)?.qty || 0;

                    if (testItemStationeryQty > 0 && stationeryItem.name.toLowerCase() != 'memo') {
                        // Decrease the qty of the reagent item
                        stationeryItem.qty -= testItemStationeryQty;
                        stationeryItem.test_ids.splice(stationeryItem.test_ids.indexOf(testItemId), 1);
                    }

                    // Check if any other test items use this reagent
                    const isStationeryUsedByOthers = this.form.ptest_items.some(item => 
                        item.id !== testItemId && 
                        item.dtconfig_stequipments.some(r => r.product_id === stationeryItem.id)
                    );

                    // If no other test items use this reagent and the qty is zero or less, remove it
                    // if (!isReagentUsedByOthers && reagentItem.qty <= 0) {
                    if (!isStationeryUsedByOthers) {
                        this.form.ptest_stequipment_items.splice(this.form.ptest_stequipment_items.indexOf(stationeryItem), 1);
                    }
                });

                // For Room Numbers 
                const testItemRoom = this.form.ptest_items[row_id].allocated_room;
                const isRoomUsedByOthers = this.form.ptest_items.some(item => 
                    item.id !== testItemId && item.allocated_room === testItemRoom
                );

                // If no other test items use this room, remove it from room_numbers
                if (!isRoomUsedByOthers) {
                    const roomIndex = this.form.room_numbers.indexOf(testItemRoom);
                    if (roomIndex !== -1) {
                        this.form.room_numbers.splice(roomIndex, 1);
                    }
                }

                // Finally, remove the test item from ptest_items
                this.form.ptest_items.splice(row_id, 1);
            } else {
                this.$toast.error("Oop's, something went wrong please try again!");
            }
        },

        onArrowDown: function(event) {
            if (this.searchTests.length > 0) {
                this.arrowCounter = event.code == "ArrowDown" ? ++this.arrowCounter : --this.arrowCounter;
                if (this.arrowCounter >= this.searchTests.length)
                this.arrowCounter = (this.arrowCounter) % this.searchTests.length;
                else if (this.arrowCounter < 0)
                this.arrowCounter = this.searchTests.length + this.arrowCounter;
                this.selectTests(this.searchTests[this.arrowCounter]);
            }
        },

        onArrowUp: function(event) {
            if (this.searchTests.length > 0) {
                this.arrowCounter = event.code == "ArrowUp" ? --this.arrowCounter : ++this.arrowCounter;
                if (this.arrowCounter >= this.searchTests.length)
                this.arrowCounter = (this.arrowCounter) % this.searchTests.length;
                else if (this.arrowCounter < 0)
                this.arrowCounter = this.searchTests.length + this.arrowCounter;
                this.selectTests(this.searchTests[this.arrowCounter]);
            }
        },

        changeDeliveryDateTime() {
            if(this.form.delivery_date != '' && this.form.ptest_items.length > 0) {
                this.form.ptest_items.forEach((pitem) => {
                    return pitem.delivery_datetime = this.form.delivery_date + ' 05:00 PM';
                });
            }
        },

        submitForm: function(e) {  
            this.isSubmit = true;
            this.disabled = true;
            const formData = new FormData();    
            formData.append('id', this.form.id);
            formData.append('bill_no', this.form.bill_no);
            formData.append('tester_by', this.form.tester_by);
            formData.append('tester_name', this.form.tester_by_name);
            formData.append('tester_specialist', this.form.tester_specialist);
            formData.append('tester_qualification', this.form.tester_qualification);
            formData.append('medical_officer_by_name', this.form.medical_officer_by_name);
            formData.append('medical_officer_qualification', this.form.medical_officer_qualification);
            formData.append('medical_officer_designation', this.form.medical_officer_designation);
            formData.append('report_type', this.form.report_type);
            formData.append('specimen', this.form.specimen);
            formData.append('exm_machine_info', this.form.exm_machine_info);
            formData.append('ptest_items', JSON.stringify(this.form.ptest_items));
            formData.append('report_items', JSON.stringify(this.form.report_items));

            var postEvent = axios.post(this.apiUrl+'/hm/diagnosis_billings/report-generate-process-store', formData, this.headers);          

            postEvent.then(res => {
                this.isSubmit = false;
                this.disabled = false;
                if(res.status == 200) {
                    this.$toast.success(res.data.message);
                    this.form.reset();
                    this.pform.reset();
                    this.forceRerender();
                    this.mannual_pathologist = false;
                    this.mannual_medical_officer = false;
                    this.form.ptest_items = [];
                    this.form.report_items = [];
                }else{
                    this.$toast.error(res.data.message);
                } 
            }).catch(err => { 
                this.isSubmit = false; 
                this.disabled = false;
                this.$toast.error(err.response.data.message);
                if(err.response.status == 422){
                    this.errors = err.response.data.errors 
                } 
            });
        }, 

        validation: function (...fiels){ 
            var obj = new Object(); 
            var validate = false;
            for (var k in fiels){     // Loop through the object  
                for (var j in this.form){  
                    if((j==fiels[k]) && (!this.form[j])) {  
                        obj[fiels[k]] = fiels[k].replace("_", " ")+' field is required';  // Delete obj[key]; 
                        this.errors = {...this.errors, ...obj};
                    }else{
                        validate = false;
                    }
                }              
            }  
            // var obj = new Object();
            // obj[fiels] = fiels.replace("_", " ")+' field is required';  
            // this.errors = {...this.errors, ...obj}; 
        },
        onkeyPress: function(field) { 
            for (var k in this.errors){     // Loop through the object
                if(k==field){      // If the current key contains the string we're looking for 
                    delete this.errors[k];  // Delete obj[key];
                }
            }  
        },

        printLabelBarcode(){
            this.printContent('labelBarcodePrint');
        },

        printInvoice: function (print_id) {   
               
            var css_url = this.baseUrlPrintCSS+'/assets/css/billing_report_print.css';
            setTimeout(() => { 
                this.printContent(print_id, css_url);
            }, 1000);
            // this.invoiceModal();
        },

        printDiagnosisReport: function (print_id) {   
            var css_url = this.baseUrlPrintCSS+'/assets/css/billing_report_print.css';
            setTimeout(() => { 
                this.printContent(print_id, css_url);
            }, 1000);
        },

        printContent(document_id, css_url='') { 
            const width = 800;
            const height = 600;
            const left = (screen.width - width) / 2;
            const top = (screen.height - height) / 2;

            const options = {
                name: '_blank',
                specs: [
                    `width=${width}`,
                    `height=${height}`,
                    `top=${top}`,
                    `left=${left}`,
                    'fullscreen=no',
                    'titlebar=yes',
                    'scrollbars=yes'
                ],
                styles: [ 
                    this.baseUrlPrintCSS+'/assets/css/bootstrap-print.min.css',
                    css_url
                ],
            };
            this.$htmlToPaper(document_id, options);
        },


    },
    destroyed() {},
    mounted() {
        window.scrollTo(0, 0);
    },
    computed: {
        
        netAmountCalculate: function () {
            let totalDiscount = this.totalGeneralDiscount + this.totalExtraDiscount;

            let totalVatTax = 0;
            let result = parseFloat(this.totalCartValue + totalVatTax - totalDiscount).toFixed(2);
            this.form.grand_total = result;   
            this.form.total_amount = parseFloat(this.totalCartValue).toFixed(2);
            return parseFloat(result).toFixed(2);
        },
        totalCartValue: function () {
            return this.form.ptest_items.reduce(function (total, item) { 
                return total + item.price * item.qty;
            }, 0);
        },

        totalDiscountPercent: function () {
            return this.discount_items.reduce(function (total, item) { 
                if(item.is_checked) {
                    return total + parseFloat(item.discount_percent);
                }else{ 
                    return total + 0;
                }
            }, 0);
        },

        totalExtraDiscountPercent: function () {
            return this.discount_items.reduce(function (total, item) { 
                if(!item.name.toLowerCase().includes('general') && item.is_checked) {
                    return total + parseFloat(item.discount_percent);
                }else{ 
                    return total + 0;
                }
            }, 0);
        },

        totalGeneralDiscount: function () {
            let generalDiscountPercent = this.totalDiscountPercent - this.totalExtraDiscountPercent;
            let extraDiscountPercent = this.totalExtraDiscountPercent;
            return this.form.ptest_items.reduce(function (total, item) {
                if(item.discount >= generalDiscountPercent) {
                    return total + (((item.price * item.qty) * generalDiscountPercent) / 100);
                }else{
                    let disc_percent = item.discount - extraDiscountPercent;
                    disc_percent = disc_percent < 0 ? 0 : disc_percent;
                    return total + (((item.price * item.qty) * (disc_percent)) / 100);
                }
            }, 0);
        },

        totalExtraDiscount: function () {
            let generalDiscountPercent = this.totalDiscountPercent - this.totalExtraDiscountPercent;
            let extraDiscountPercent = this.totalExtraDiscountPercent;
            return this.form.ptest_items.reduce(function (total, item) {
                if(item.discount > generalDiscountPercent && item.discount > 0) {
                    return total + (((item.price * item.qty) * (item.discount - generalDiscountPercent)) / 100);
                }else{
                    return total + (((item.price * item.qty) * (extraDiscountPercent)) / 100);
                }
            }, 0)
        },


        // Group tests by category_name and remove empty categories
        groupedTests() {
            if (!Array.isArray(this.form.ptest_items) || this.form.ptest_items.length === 0) return {};

            // Expect each test_option to have: id, name, category_id (optional), category_name (string)
            const groups = {};

            this.form.ptest_items.forEach(t => {
                // normalize category id
                const cat = t.category_name;

                if (!cat) return; // skip if category empty string
                if (!groups[cat]) groups[cat] = [];
                groups[cat].push(t);
            });

            // remove categories that ended up with zero items (shouldn't happen, but safe)
            Object.keys(groups).forEach(k => {
                if (!groups[k] || groups[k].length === 0) delete groups[k];
            });

            return groups;
        }
    },

    watch: {
        // watch the array for changes
        'pform.test_ids': {
            handler(newVal) {
                this.checkSameCategoryItem(newVal);
            },
            deep: true
        }
    },

}
</script>
<style scoped>
    .modal-content.scrollbar-width-thin {
        border: none !important;
    }

    label {
        display: inline-block;
        margin: 0px 0px 4px 2px;
        float: left;
    }

    .invalid-feedback {
        display: block;
        width: 100%;
        margin-top: 0.25rem;
        font-size: 80%;
        color: #dc3545;
        text-align: left;
    }

    #newBilling hr {
        margin-top: 0px !important;
    }

    .wpr_general_sign_title {
        width: 100%;
        display: block;
        padding: 8px 20px;
        background-color: #313A46;
        display: block;
        color: #fff;
        font-weight: 700;
        font-size: 18px;
    }

    
    /** Autocomplete */
    .autocomplete {
        position: relative;
    }

    ul.autocomplete-results {
        width: 100% !important;
        margin-top: 1px !important;
        position: absolute;
        left: 0;
        z-index: 999;
    }
    .autocomplete-results {
        padding: 0;
        margin: 0;
        border: 1px solid #eeeeee;
        /* height: 120px; */
        overflow: auto;
        width: 100%;
    }

    .autocomplete-results li{
        list-style: none;
        text-align: left;
        padding: 4px 2px;
        cursor: pointer;
    /* background: red; */
    }

    .autocomplete-results li.is-active,
    .autocomplete-results li:hover {
        background-color: #4AAE9B;
        color: white;
    }
    .autocomplete-results li:first-child {
        font-weight: 600;
        border-bottom: 1px solid #282828;
        margin-bottom: 3px;
    }
    .autocomplete-results li:first-child:hover {
        background-color: inherit;
        color: inherit;
    }

    .is-active {
        background-color: #dedede;
    }

    ul.discount_items {
        list-style: none;
        padding: 0;
    }

    ul.discount_items li {
        display: block;
        margin-right: 5px;
        clear: both;
    }

    ul.discount_items li .discount_fields .item_field input{
        margin-bottom: 5px;
    }

    /** For Invoice modal css */
    .modal-content.scrollbar-width-thin.invoice-modal {
        width: 100%;
        display: block;
        margin: auto;
    }

    .invoice-billing {
        font-family: Verdana, Geneva, Tahoma, sans-serif;
    }

    .invoice-billing #top h2{
        font-size: 18px;
    }

    .invoice-billing #top h5{
        font-size: 14px;
    }

    .invoice-billing #top .top_add_info h2 {
        font-size: 32px;
        text-align: right;
        margin-bottom: 0;
        text-transform: uppercase;
        font-family: Cambria, Cochin, Georgia, Times, 'Times New Roman', serif;
        color: #cecece;
    }
    .invoice-billing #top .category-title{
        background: #ffffff;
        box-shadow: 0px 2px 2px #282828;
        padding: 5px 10px;
    }

    .invoice-billing #top p{
        font-size: 14px;
    }

    .invoice-billing .report-logo {
        margin-left: -15px;
        margin-top: -15px;
    }

    .invoice-billing #mid {
        margin-bottom: 10px;
    }

    #mid .info {
        border: 1px solid #282828;
        padding: 0 10px 5px 10px;
        border-radius: 10px;
        margin-bottom: 10px;
    }

    #mid .info table {
        width: 100%;
    }

    #mid .info table tr td{
        font-size: 14px;
    }

    #mid .info table tr td#pname {
        font-weight: 550;
        font-size: 15px;
        text-transform: uppercase;
    }

    #bot .machine_info h6 {
        font-size: 10px;
        margin: 5px 0;
    }

    #bot .items-info table thead {
        border: 1px solid #282828;
        font-size: 14px;
    }

    #bot .items-info table thead td{
        padding: 0 10px;
    }

    #bot .items-info table tbody tr{
        border-bottom: 0 solid #e0e0e0;
    }
    #bot .items-info table tbody td{
        padding: 3px 10px;
        font-size: 12px;
    }

    .corporate-payment-info {
        margin-top: 10px;
    }

    .corporate-info p{
        font-size: 14px;
    }

    .payment-info {
        width: 100%;
        border: none;
    }

    .payment-info tr {
        border-bottom: 0 !important;
    }

    .payment-info tr td{
        padding: 3px 10px;
        font-size: 14px;
        border: 0 !important;
        border-top: 0 !important;
        border-bottom: 0 !important;
    }

    .status-signatures {
        margin-top: 10px;
    }

    .status-info h3 {
        font-size: 18px;
    }

    .status-info h3 span {
        padding: 5px; 
        font-size: 22px;
        border: 1px solid #282828; 
        border-radius: 0px;
    }

    .status-info span {
        font-size: 11px;
    }

    .signature-info {
        text-align: left;
    }
    .signature-info h4 {
        text-align: left;
        font-size: 16px;
        border-bottom: 0 solid #e0e0e0;
        margin-bottom: 5px;
        padding-bottom: 2px;
    }

    .signature-info span {
        font-size: 14px;
        text-align: center;
        border-top: 1px dashed #e0e0e0;
    }

    .room-info {
        margin-top: 10px;
    }

    .room-info p {
        font-size: 13px;
    }

    .room-info p span {
        padding: 5px 10px;
        font-size: 13px;
        margin-right: 5px;
        border: 1px solid #282828;
        border-radius: 0;
    }

    .legal-info {
        margin-top: 10px;
    }

    .legal-info h6 {
        text-align: center;
        font-size: 13px;
        margin-top: 0;
        margin-bottom: 7px;
    }

</style>